import React from 'react';
import { ContextualMenu } from '@cldf/scotiaweb-menu/lib/menu.es';
import PropTypes from 'prop-types';
import { UserActionDataModel } from '../../services/api/api.services';
import {sanitizeUrl} from '@braintree/sanitize-url';

const navigationResolver = (type, target) => ({
  onClick: event => {
    event.preventDefault();
    const { protocol, host } = window.location;
    const newUrl = `${protocol}//${host}/cgi-bin/transac/dotrx?TMPL=/index.html&enc=UTF-8#mfe${target}`;
    window.parent.location.href = sanitizeUrl.sanitizeUrl(newUrl);
  },
});
const STYLE = {
  display: 'flex',
  marginRight: '-35px',
  marginTop: '-10px',
  paddingLeft: '4px',
  float: 'right',
};

/**
 * Context menu for the pending products.
 * @param {Object} props
 * @param {UserActionDataModel} props.actions - {@link UserActionDataModel} used to polulate the component.
 * @returns React component
 */
const ContextMenu = props => {
  const { actions } = props;
  const menus = (actions || []).map(a => ({ label: a.name, type: 'URL', target: `${a.link}` }));

  return menus.length == 0 ? (
    <div />
  ) : (
    <div style={STYLE}>
      <ContextualMenu menu={menus} navigationResolver={navigationResolver} context={{}} />
    </div>
  );
};

export default ContextMenu;

ContextMenu.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
};
ContextMenu.defaultProps = {
  actions: [],
};
